/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TokenResponse } from './tokenResponse';

/**
 * CLI login response with token and profile metadata.
 */
export interface CliLoginResponse {
  token: TokenResponse;
  userId: string;
  username: string;
  role: string;
  tenantId: string;
  tenantSlug: string;
  accessExpiresAt: string;
}
